import employeeReducer from './employeeConfirmation/employeeSlice';
import ticketReducer from './ticket/ticketSlice';

const employeeReducers = {
    employee: employeeReducer,
    ticket: ticketReducer,
   

};

export default employeeReducers;
